import React from "react";
import "./BlogListLoader.css";

export default function BlogListLoader({ count = 6, label = "Loading blog posts" }) {
    const safeCount = Number.isFinite(count) ? Math.max(1, Math.min(12, Math.floor(count))) : 6;

    return (
        <div className="pbl-loader-grid" role="status" aria-label={label} aria-busy="true">
            {Array.from({ length: safeCount }).map((_, idx) => (
                <div className="pbl-loader-card" key={idx} aria-hidden="true">
                    <div className="pbl-loader-block pbl-loader-image" />
                    <div className="pbl-loader-block pbl-loader-title" />
                    <div className="pbl-loader-block pbl-loader-text" />
                    <div className="pbl-loader-block pbl-loader-text" />
                    <div className="pbl-loader-block pbl-loader-text last" />
                    <div className="pbl-loader-meta">
                        <div className="pbl-loader-block pbl-loader-date" />
                        <div className="pbl-loader-block pbl-loader-cta" />
                    </div>
                </div>
            ))}
        </div>
    );
}

